import { useTranslation } from 'react-i18next';

export interface CategoryLink {
  name: string;
  key: string;
  url: string;
}

export const categoryLinks: CategoryLink[] = [
  { name: 'Shoes', key: 'shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies/Sweaters', key: 'hoodies_sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', key: 't_shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jackets', key: 'jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Pants/Shorts', key: 'pants_shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Headwear', key: 'headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Sets', key: 'sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'underwear/underpants', key: 'underwear', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Jersey', key: 'jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Accessories', key: 'accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Bags', key: 'bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Belts', key: 'belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Perfumes', key: 'perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Other Stuff', key: 'other_stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

export interface Article {
  slug: string;
  category: string;
  title: string;
  description: string;
  date: string;
  updated: string;
  readTime: string;
  image: string;
}

export const articles: Article[] = [
  {
    slug: 'cssbuy-spreadsheet-guide',
    category: 'article_category_spreadsheet',
    title: 'article_spreadsheet_guide',
    description: 'article_spreadsheet_desc',
    date: '2026-08-15',
    updated: '2026-08-27',
    readTime: '8 min',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20workspace%20with%20laptop%20showing%20an%20organized%20spreadsheet%20grid%20on%20a%20soft%20beige%20desk%2C%20warm%20natural%20light%2C%20editorial%20photography%2C%20clean%20productivity%20scene&width=600&height=400&seq=card-spreadsheet&orientation=landscape',
  },
  {
    slug: 'cssbuy-shipping-guide',
    category: 'article_category_shipping',
    title: 'article_shipping_guide',
    description: 'article_shipping_guide_desc',
    date: '2026-08-20',
    updated: '2026-08-27',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=Stacked%20cardboard%20shipping%20boxes%20with%20labels%20on%20a%20soft%20neutral%20surface%2C%20warm%20natural%20light%2C%20editorial%20photography%2C%20clean%20logistics%20delivery%20scene&width=600&height=400&seq=card-shipping&orientation=landscape',
  },
  {
    slug: 'cssbuy-safety-guide',
    category: 'article_category_safety',
    title: 'article_safety_guide',
    description: 'article_safety_guide_desc',
    date: '2026-08-22',
    updated: '2026-08-27',
    readTime: '5 min',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20security%20shield%20and%20padlock%20on%20a%20soft%20cream%20background%2C%20warm%20natural%20light%2C%20editorial%20product%20photography%2C%20safety%20protection%20concept&width=600&height=400&seq=card-safety&orientation=landscape',
  },
  {
    slug: 'cssbuy-review',
    category: 'article_category_review',
    title: 'article_review_title',
    description: 'article_review_desc',
    date: '2026-08-18',
    updated: '2026-08-27',
    readTime: '9 min',
    image: 'https://readdy.ai/api/search-image?query=Gold%20rating%20stars%20above%20a%20clean%20desk%20with%20a%20tablet%20and%20notes%2C%20warm%20amber%20studio%20lighting%2C%20premium%20review%20concept%2C%20soft%20gradient%20background&width=600&height=400&seq=card-review&orientation=landscape',
  },
  {
    slug: 'cssbuy-coupon',
    category: 'article_category_coupon',
    title: 'article_coupon_title',
    description: 'article_coupon_desc',
    date: '2026-08-19',
    updated: '2026-08-27',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=Gift%20voucher%20and%20discount%20tag%20with%20scissors%20on%20a%20coral%20pink%20background%2C%20playful%20ecommerce%20sale%20concept%2C%20bright%20studio%20lighting%2C%20clean%20composition&width=600&height=400&seq=card-coupon&orientation=landscape',
  },
  {
    slug: 'cssbuy-warehouse',
    category: 'article_category_warehouse',
    title: 'article_warehouse_title',
    description: 'article_warehouse_desc',
    date: '2026-08-20',
    updated: '2026-08-27',
    readTime: '7 min',
    image: 'https://readdy.ai/api/search-image?query=Neat%20rows%20of%20cardboard%20parcels%20on%20industrial%20shelving%20in%20a%20bright%20modern%20warehouse%2C%20soft%20daylight%2C%20logistics%20storage%20concept%2C%20clean%20composition&width=600&height=400&seq=card-warehouse&orientation=landscape',
  },
  {
    slug: 'cssbuy-qc',
    category: 'article_category_qc',
    title: 'article_qc_title',
    description: 'article_qc_desc',
    date: '2026-08-21',
    updated: '2026-08-27',
    readTime: '8 min',
    image: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20inspecting%20a%20folded%20garment%20on%20a%20sage%20green%20table%2C%20quality%20control%20inspection%20concept%2C%20soft%20natural%20window%20light%2C%20editorial%20photography&width=600&height=400&seq=card-qc&orientation=landscape',
  },
  {
    slug: 'cssbuy-alternatives',
    category: 'article_category_comparison',
    title: 'article_alternatives_title',
    description: 'article_alternatives_desc',
    date: '2026-08-22',
    updated: '2026-08-27',
    readTime: '8 min',
    image: 'https://readdy.ai/api/search-image?query=Two%20paths%20splitting%20on%20a%20minimal%20teal%20background%20with%20arrows%20pointing%20in%20different%20directions%2C%20choice%20and%20comparison%20concept%2C%20clean%20flat%20illustration%20style&width=600&height=400&seq=card-alternatives&orientation=landscape',
  },
  {
    slug: 'cssbuy-beginner-guide',
    category: 'article_category_beginner',
    title: 'article_beginner_title',
    description: 'article_beginner_desc',
    date: '2026-08-23',
    updated: '2026-08-27',
    readTime: '7 min',
    image: 'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20step%20by%20step%20checklist%20and%20coffee%20on%20a%20warm%20cream%20desk%2C%20learning%20and%20getting%20started%20concept%2C%20cozy%20natural%20light%2C%20editorial%20photography&width=600&height=400&seq=card-beginner&orientation=landscape',
  },
  {
    slug: 'cssbuy-shipping-brazil',
    category: 'article_category_shipping',
    title: 'article_brazil_title',
    description: 'article_brazil_desc',
    date: '2026-08-24',
    updated: '2026-08-27',
    readTime: '7 min',
    image: 'https://readdy.ai/api/search-image?query=Cardboard%20parcel%20with%20green%20and%20yellow%20ribbon%20on%20a%20wooden%20table%2C%20Brazil%20shipping%20concept%2C%20warm%20tropical%20light%2C%20clean%20product%20photography&width=600&height=400&seq=card-brazil&orientation=landscape',
  },
  {
    slug: 'cssbuy-shipping-germany',
    category: 'article_category_shipping',
    title: 'article_germany_title',
    description: 'article_germany_desc',
    date: '2026-08-25',
    updated: '2026-08-27',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=Cardboard%20parcel%20with%20black%20red%20and%20gold%20ribbon%20on%20a%20slate%20table%2C%20Germany%20shipping%20concept%2C%20cool%20studio%20lighting%2C%20clean%20product%20photography&width=600&height=400&seq=card-germany&orientation=landscape',
  },
  {
    slug: 'cssbuy-spreadsheet-shoes',
    category: 'article_category_spreadsheet',
    title: 'article_shoes_title',
    description: 'article_shoes_desc',
    date: '2026-08-26',
    updated: '2026-08-27',
    readTime: '7 min',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20sneakers%20arranged%20in%20a%20row%20on%20a%20light%20concrete%20surface%2C%20vibrant%20footwear%20photography%2C%20bright%20studio%20lighting%2C%20energetic%20streetwear%20composition&width=600&height=400&seq=card-shoes&orientation=landscape',
  },
  {
    slug: 'cssbuy-spreadsheet-hoodies',
    category: 'article_category_spreadsheet',
    title: 'article_hoodies_title',
    description: 'article_hoodies_desc',
    date: '2026-08-27',
    updated: '2026-08-27',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=Stack%20of%20folded%20pastel%20hoodies%20on%20a%20soft%20lavender%20background%2C%20cozy%20fashion%20photography%2C%20gentle%20natural%20light%2C%20clean%20minimal%20composition&width=600&height=400&seq=card-hoodies&orientation=landscape',
  },
];

export interface FAQItem {
  question: string;
  answer: string;
}

export const getFAQItems = (t: ReturnType<typeof useTranslation>['t']): FAQItem[] => [
  {
    question: t('faq_what_is'),
    answer: 'CSSBuy Spreadsheet is an independent product discovery and comparison resource. It helps users find products, compare sellers, check QC photos, and understand shipping costs before making a purchase. The spreadsheet is organized by category with regular updates to ensure accurate information.',
  },
  {
    question: t('faq_how_to_use'),
    answer: 'To use the CSSBuy Spreadsheet, select a category from the dropdown menu or click on a product category button. Each category link will take you to the main website where you can browse products, compare prices, and check seller ratings. Use the search bar to find specific products by name or keyword.',
  },
  {
    question: t('faq_legit'),
    answer: 'CSSBuy is a known agent service for purchasing products from Chinese marketplaces. Like any third-party platform, there are inherent risks. The platform has been operating for several years and has a user base. However, we always recommend doing your own research, checking seller reviews, and understanding the risks before making purchases.',
  },
  {
    question: t('faq_safe'),
    answer: 'Safety depends on multiple factors: seller reputation, payment method, QC process, and shipping reliability. Always use the QC photo service, verify seller ratings, and choose secure payment methods. Read our Safety Guide for detailed recommendations.',
  },
  {
    question: t('faq_shipping_cost'),
    answer: 'Shipping costs vary based on weight, dimensions, destination country, and shipping method. CSSBuy offers multiple shipping lines including EMS, DHL, FedEx, and postal services. Volumetric weight may apply to some packages. Use the shipping calculator on the main website for exact pricing.',
  },
  {
    question: t('faq_qc'),
    answer: 'QC (Quality Control) is the process of inspecting your items before they are shipped from the warehouse. CSSBuy provides QC photos showing the actual product, allowing you to verify quality, sizing, and condition. You can request additional photos or return items if they do not match the description.',
  },
  {
    question: t('faq_warehouse'),
    answer: 'The CSSBuy warehouse is where your purchased items are stored before shipping. Services include storage, QC inspection, photo taking, consolidation (combining multiple orders into one package), and repackaging. Storage duration and fees vary by plan.',
  },
  {
    question: t('faq_find_products'),
    answer: 'Products can be found through the category dropdown menu, category buttons on the homepage, or by using the search function. You can also browse the main website directly for the latest product listings and search by keyword, brand, or category.',
  },
  {
    question: t('faq_brazil'),
    answer: 'Yes, CSSBuy ships to Brazil. Shipping methods and costs vary. Common options include EMS and postal services. Be aware that Brazilian customs may charge import duties and taxes. Check our Brazil Shipping Guide for detailed information.',
  },
  {
    question: t('faq_coupons'),
    answer: 'Coupons and discount codes may be available from CSSBuy during promotional periods. We do not publish unverified codes. Always check the official platform or our Coupon Guide for current, valid promotions. Never trust third-party coupon sites claiming guaranteed discounts.',
  },
];